import CrudManager from "@/components/admin/CrudManager";
import { resolveSrc } from "@/components/admin/ImageField";

export default function AdminGallery() {
  return (
    <CrudManager
      title="Galerij"
      subtitle="Beheer de foto's in de scrollende carrousel op de homepagina"
      listEndpoint="/gallery"
      adminEndpoint="/admin/gallery"
      fields={[
        { name: "image_url", label: "Foto", type: "image", required: true },
        { name: "caption", label: "Bijschrift (optioneel)" },
        { name: "order", label: "Volgorde", type: "number", default: 0 },
      ]}
      columns={[
        { key: "order", label: "#" },
        { key: "image_url", label: "Foto", render: (it) => <img src={resolveSrc(it.image_url)} alt="" className="h-12 w-16 object-cover rounded" /> },
        { key: "caption", label: "Bijschrift" },
      ]}
    />
  );
}
